import { render, staticRenderFns } from "./VenueSetup.vue?vue&type=template&id=4cd0be59&scoped=true&"
import script from "./VenueSetup.vue?vue&type=script&lang=js&"
export * from "./VenueSetup.vue?vue&type=script&lang=js&"
import style0 from "./VenueSetup.vue?vue&type=style&index=0&id=4cd0be59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd0be59",
  null
  
)

export default component.exports